module.exports = __webpack_public_path__ + "static/media/landpage6Desktop.9b688199.png";